import OMap from "../utils/OMap";
import Omy from "../Omy";
import OActor from "../display/actors/OActor";

export default class GameCache {
    constructor(stage) {
        /** @type {OMap} */
        this.actorStorage = new OMap();
        this._stage = stage;
    }

    setActorAtlas(a) {
        if (!this.actorStorage.has(a._cacheName)) {
            Omy.error("not exists this entity in storage!!! name", a._cacheName);
            return;
        }
        this.actorStorage.get(a._cacheName).push(a);
        this._stage.addChild(a);
        a.timer = Omy.add.timer(0.01, this._trueVisible, this, 0, false, true, 0, [a]);
        a = null;
    }

    /**     * @private     */
    _trueVisible(a) {
        a.visible = true;
        a.renderable = true;
        a.x = 5 * Omy.WIDTH + a.width;
        a.y = 5 * Omy.HEIGHT + a.height;
        a.timer = null;
    }

    getActorAtlas(name, textures, nameAnimation) {
        if (!this.actorStorage.has(name)) {
            this.actorStorage.set(name, []);
        }

        let answer = null;
        if (this.actorStorage.get(name).length) {
            answer = this.actorStorage.get(name).shift();
            if (answer.timer) {
                answer.timer.destroy();
                answer.timer = null;
            }
        } else {
            answer = new OActor(textures, nameAnimation);
            answer._cacheName = name;
        }
        return answer;
    }
}
